import logo from "../../assets/images/logo200-white.svg";

import { Link } from "react-router-dom";
import Profile from "./Profile";

export default function Header() {
  return (
    <div className="">
      <div className=" bg-fish flex justify-between items-center px-4 py-2">
        <Link to={"/"} className="flex  items-center justify-center">
          <div className="flex items-center">
            <img src={logo} alt="" width={240} />
          </div>
        </Link>
        <div className="hidden lg:flex text-white text-xl">
          CREDIT LIMIT & APPROVAL MATRIX
        </div>
        <div className="flex flex-row items-center">
          <div className="text-white font-bold bg-green-100"></div>
          <div className="ml-2 mr-4 z-50">
            <Profile />
          </div>
        </div>
      </div>
      <div className="lg:hidden bg-fish-dark  text-center text-white text-xxs ">
        CREDIT LIMIT & APPROVAL MATRIX
      </div>
    </div>
  );
}
